export default {
  strict: true,
  namespaced: true,
  state: {
    hotelKey: null,
    selectedRooms: null,
    unfinishedId: null,
    current: {
      formData: null,
      fakeBooking: null
    }
  },
  mutations: {
    setHotelKey: (state, payload) => {
      state.hotelKey = payload
    },
    setSelectedRooms: (state, payload) => {
      state.selectedRooms = payload
    },
    setUnfinishedId: (state, payload) => {
      state.unfinishedId = payload
    },
    setCurrent: (state, payload) => {
      state.current = payload
    },
    resetCurrent: (state) => {
      state.current = {
        formData: null,
        fakeBooking: null
      }
    },
    reset: (state, payload) => {
      state.hotelKey = null
      state.selectedRooms =  null
      state.unfinishedId = null
      state.current = {
        formData: null,
        fakeBooking: null
      }
    }
  }
}
